import React from 'react';
import { StyledRow, BaseColumn } from '../../shared/sharedStyles.styles';
import FilterField from './FilterField';
import DateSearchField from './DateSearchField';
import { FilterIcon, FilterButton, FilterText } from './SearchStyles';
import filter from '../../../img/svg/ico-filter.svg';
import {
  RequestsFilterCardMobile,
  RequestsFilterFormMobile,
  RequestsSearchFieldGroup,
  RequestsDateFieldGroup,
  RequestsMobileDateRangeRow
} from './searchFilterToolbar.styles';

const SearchGroupMobile = ({
  setFilter,
  endDate,
  startDate,
  filterDate,
  hiddenInputFilter
}) => {
  return (
    <StyledRow customStyle="z-index: 2;">
      <BaseColumn xs="12" sm="12" md="12" lg="12" xl="12">
        <RequestsFilterCardMobile>
          <RequestsFilterFormMobile
            onSubmit={e => {
              e.preventDefault();
              filterDate();
            }}
          >
            {!hiddenInputFilter && (
              <RequestsSearchFieldGroup>
                <FilterIcon src={filter} alt="" />
                <FilterField
                  type="text"
                  placeholder="Filtrar id, endereço, pretendente e CPF/CNPJ..."
                  submitSearch={setFilter}
                  noIcon={true}
                />
              </RequestsSearchFieldGroup>
            )}

            <RequestsDateFieldGroup>
              <RequestsMobileDateRangeRow>
                <FilterIcon src={filter} alt="" style={{ marginRight: '2px' }} />
                <FilterText style={{ fontWeight: 600, fontSize: '12px' }}>De</FilterText>
                <DateSearchField
                  type="text"
                  placeholder="dd/mm/aaaa"
                  submitSearch={startDate}
                />
                <FilterText style={{ fontWeight: 600, fontSize: '12px' }}>a</FilterText>
                <DateSearchField
                  type="text"
                  placeholder="dd/mm/aaaa"
                  submitSearch={endDate}
                />
              </RequestsMobileDateRangeRow>
              <FilterButton type="submit">Filtrar</FilterButton>
            </RequestsDateFieldGroup>
          </RequestsFilterFormMobile>
        </RequestsFilterCardMobile>
      </BaseColumn>
    </StyledRow>
  );
};

export default SearchGroupMobile;
